import React, { useState, useContext } from 'react';
import AppBar from './components/AppBar';
import { Stack, Button, Text, TextArea, Spinner, Radio, Input, FormControl } from 'native-base';
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { VStack } from 'native-base';
import { postNewArea } from "./services/picnicapi"
import AlertBox from "./components/AlertBox"
import { LanguageContext } from './context/LanguageProvider';
import fire from "./firebase/firebase"
import { Formik } from 'formik';

export default function NewAreaPage() {
    let { state } = useLocation();
    const { i18n } = useContext(LanguageContext)
    const [loading, setLoading] = useState(false);
    const [showSuccess, setShowSucces] = useState(false);
    const navigate = useNavigate();

    fire.logEvent("abrir_nueva_area");

    const validate = (values) => {
        console.log(values)
        const errors = {};
        if (!values.nombre.length > 0) {
            errors.nombre = i18n.t("nueva_zona_error_nombre")
        }
        if (!values.ciudad.length > 0) {
            errors.ciudad = i18n.t("nueva_zona_error_ciudad")
        }
        if (!values.pais.length > 0) {
            errors.pais = i18n.t("nueva_zona_error_país")
        }
        if (!Number.isInteger(parseInt(values.num_aseos))) {
            errors.num_aseos = i18n.t("nueva_zona_error_aseos")
        }
        if (!Number.isInteger(parseInt(values.num_mesas))) {
            errors.num_mesas = i18n.t("nueva_zona_error_mesas")
        }
        if (!Number.isInteger(parseInt(values.num_fuentes))) {
            errors.num_fuentes = i18n.t("nueva_zona_error_fuentes")
        }
        return errors;
    }

    const onSubmit = async (values) => {
        setLoading(true);
        postNewArea(values)
            .then((response) => {
                if (response) { //si es true
                    setLoading(false);
                    setShowSucces(true);
                    fire.logEvent("nueva_area", { name: values.nombre });
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    }
    const onCloseSucces = () => {
        navigate(-1);
    }

    return (<>
        <AppBar title={i18n.t("nueva_zona_add_btn")} backButton={true} />
        <Formik initialValues={{
            nombre: "",
            lat: state?.lat,
            lon: state?.lng,
            descripcion: "",
            ciudad: "",
            pais: "",
            zona_banyo: false,
            bar: false,
            zona_infantil: false,
            barbacoa: false,
            tipo_suelo: "tierra",
            num_aseos: 0,
            num_mesas: 0,
            num_fuentes: 0,
            url_imagen: ""
        }}
            onSubmit={onSubmit}
            validate={validate}
            validateOnChange={false}
            validateOnBlur={false}
        >
            {({
                handleChange,
                handleBlur,
                handleSubmit,
                values,
                errors,
                setFieldValue,
            }) => (
                showSuccess ? (<AlertBox
                    header={i18n.t("nueva_zona_add_btn")}
                    body={i18n.t("nueva_zona_creada")}
                    isOpen={showSuccess}
                    textButton1={i18n.t("btn_ok")}
                    onPressButton1={() => onCloseSucces()} />) : (
                    <VStack alignItems="left" space="5" mb="2rem" padding="30px">
                        <div style={{ marginTop: "70px" }} />
                        <FormControl isRequired isInvalid={'nombre' in errors}>
                            <FormControl.Label alignItems="baseline">{i18n.t("nueva_zona_nombre")}</FormControl.Label>
                            <Input onBlur={handleBlur('nombre')} onChangeText={handleChange('nombre')} value={values.nombre} />
                            <FormControl.ErrorMessage _text={{
                                fontSize: 'xs'
                            }}>
                                {errors.nombre}
                            </FormControl.ErrorMessage>
                        </FormControl>
                        <div>
                            <FormControl.Label>{i18n.t("nueva_zona_descripcion")}</FormControl.Label>
                            <TextArea h={20} width="100%" onBlur={handleBlur('descripcion')} onChangeText={handleChange('descripcion')} value={values.descripcion} />
                        </div>
                        <FormControl isRequired mt isInvalid={'ciudad' in errors}>
                            <FormControl.Label alignItems="baseline">{i18n.t("nueva_zona_ciudad")}</FormControl.Label>
                            <Input onBlur={handleBlur('ciudad')} onChangeText={handleChange('ciudad')} value={values.ciudad} />
                            <FormControl.ErrorMessage _text={{
                                fontSize: 'xs'
                            }}>
                                {errors.ciudad}
                            </FormControl.ErrorMessage>
                        </FormControl>

                        <FormControl isRequired mt isInvalid={'pais' in errors}>
                            <FormControl.Label alignItems="baseline">{i18n.t("nueva_zona_pais")}</FormControl.Label>
                            <Input onBlur={handleBlur('pais')} onChangeText={handleChange('pais')} value={values.pais} />
                            <FormControl.ErrorMessage _text={{
                                fontSize: 'xs'
                            }}>
                                {errors.pais}
                            </FormControl.ErrorMessage>
                        </FormControl>
                        <FormControl mt>
                            <FormControl.Label>{i18n.t("nueva_zona_zona_banyo")}</FormControl.Label>
                            <Radio.Group
                                accessibilityLabel={i18n.t("nueva_zona_zona_banyo")}
                                size="sm"
                                defaultValue={values.zona_banyo}
                                onChange={(value) => setFieldValue('zona_banyo', value)}>
                                <Stack direction={{
                                    base: "row"
                                }} alignItems={{
                                    base: "flex-start",
                                }} space={4} >
                                    <Radio value={true} my="1">
                                        {i18n.t("si")}
                                    </Radio>
                                    <Radio value={false} my="1">
                                        {i18n.t("no")}
                                    </Radio>
                                </Stack>
                            </Radio.Group>
                        </FormControl>
                        <FormControl mt>
                            <FormControl.Label>{i18n.t("nueva_zona_bar")}</FormControl.Label>
                            <Radio.Group
                                accessibilityLabel={i18n.t("nueva_zona_bar")}
                                size="sm"
                                defaultValue={values.bar}
                                onChange={(value) => setFieldValue('bar', value)}>
                                <Stack direction={{
                                    base: "row"
                                }} alignItems={{
                                    base: "flex-start",
                                }} space={4} >
                                    <Radio value={true} my="1">
                                        {i18n.t("si")}
                                    </Radio>
                                    <Radio value={false} my="1">
                                        {i18n.t("no")}
                                    </Radio>
                                </Stack>
                            </Radio.Group>
                        </FormControl>
                        <FormControl mt>
                            <FormControl.Label>{i18n.t("nueva_zona_zona_infantil")}</FormControl.Label>
                            <Radio.Group
                                accessibilityLabel={i18n.t("nueva_zona_zona_infantil")}
                                size="sm"
                                defaultValue={values.zona_infantil}
                                onChange={(value) => setFieldValue('zona_infantil', value)}>
                                <Stack direction={{
                                    base: "row"
                                }} alignItems={{
                                    base: "flex-start",
                                }} space={4} >
                                    <Radio value={true} my="1">
                                        {i18n.t("si")}
                                    </Radio>
                                    <Radio value={false} my="1">
                                        {i18n.t("no")}
                                    </Radio>
                                </Stack>
                            </Radio.Group>
                        </FormControl>
                        <FormControl mt>
                            <FormControl.Label>{i18n.t("nueva_zona_barbacoa")}</FormControl.Label>
                            <Radio.Group
                                accessibilityLabel={i18n.t("nueva_zona_barbacoa")}
                                size="sm"
                                defaultValue={values.barbacoa}
                                onChange={(value) => setFieldValue('barbacoa', value)}>
                                <Stack direction={{
                                    base: "row"
                                }} alignItems={{
                                    base: "flex-start",
                                }} space={4} >
                                    <Radio value={true} my="1">
                                        {i18n.t("si")}
                                    </Radio>
                                    <Radio value={false} my="1">
                                        {i18n.t("no")}
                                    </Radio>
                                </Stack>
                            </Radio.Group>
                        </FormControl>
                        <FormControl mt>
                            <FormControl.Label>{i18n.t("nueva_zona_tipo_suelo")}</FormControl.Label>
                            <Radio.Group
                                accessibilityLabel={i18n.t("nueva_zona_tipo_suelo")}
                                size="sm"
                                defaultValue={values.tipo_suelo}
                                onChange={handleChange('tipo_suelo')}>
                                <Stack direction={{
                                    base: "column",
                                    md: "row"
                                }} alignItems={{
                                    base: "flex-start",
                                }} space={4} >
                                    <Radio value="tierra" my="1">
                                        {i18n.t("tierra")}
                                    </Radio>
                                    <Radio value="cesped" my="1">
                                        {i18n.t("cesped")}
                                    </Radio>
                                    <Radio value="piedras" my="1">
                                        {i18n.t("piedras")}
                                    </Radio>
                                    <Radio value="arena" my="1">
                                        {i18n.t("arena")}
                                    </Radio>
                                    <Radio value="asfalto" my="1">
                                        {i18n.t("asfalto")}
                                    </Radio>
                                </Stack>
                            </Radio.Group>
                        </FormControl>

                        <FormControl isRequired mt isInvalid={'num_aseos' in errors}>
                            <FormControl.Label alignItems="baseline">{i18n.t("nueva_zona_aseos")}</FormControl.Label>
                            <Input onBlur={handleBlur('num_aseos')} onChangeText={(value) => setFieldValue('num_aseos', value?.length > 0 ? parseInt(value, 10) : 0)} value={values.num_aseos} />
                            <FormControl.ErrorMessage _text={{
                                fontSize: 'xs'
                            }}>
                                {errors.num_aseos}
                            </FormControl.ErrorMessage>
                        </FormControl>

                        <FormControl isRequired mt isInvalid={'num_mesas' in errors}>
                            <FormControl.Label alignItems="baseline">{i18n.t("nueva_zona_mesas")}</FormControl.Label>
                            <Input onBlur={handleBlur('num_mesas')} onChangeText={(value) => setFieldValue('num_mesas', value?.length > 0 ? parseInt(value, 10) : 0)} value={values.num_mesas} />
                            <FormControl.ErrorMessage _text={{
                                fontSize: 'xs'
                            }}>
                                {errors.num_mesas}
                            </FormControl.ErrorMessage>
                        </FormControl>

                        <FormControl isRequired mt isInvalid={'num_fuentes' in errors}>
                            <FormControl.Label alignItems="baseline">{i18n.t("nueva_zona_fuentes")}</FormControl.Label>
                            <Input onBlur={handleBlur('num_fuentes')} onChangeText={(value) => setFieldValue('num_fuentes', value?.length > 0 ? parseInt(value, 10) : 0)} value={values.num_fuentes} />
                            <FormControl.ErrorMessage _text={{
                                fontSize: 'xs'
                            }}>
                                {errors.num_fuentes}
                            </FormControl.ErrorMessage>
                        </FormControl>
                        {loading ? (
                            <Spinner size="lg" color='darkolivegreen' />) :
                            (<Button block style={{ backgroundColor: 'darkolivegreen' }} onPress={handleSubmit}>
                                <Text style={{ color: 'white' }}>{i18n.t("nueva_zona_add_btn")}</Text>
                            </Button>)}
                    </VStack>)
            )}
        </Formik>
    </>
    );
}